import React, { useMemo } from 'react';
import { Col, Row, Spin, Collapse, Icon, Button } from 'antd';
import moment from 'moment';
import { useGetEnochReportLogsHistory } from '../../../../query/enoch';
import _ from 'lodash';

const customPanelStyle = {
  marginBottom: 0,
  border: 0,
  overflow: 'hidden',
};

export default function ReportDetailModal({ report }) {
  const {
    isFetching,
    isFetchingNextPage,
    data,
    hasNextPage,
    fetchNextPage,
  } = useGetEnochReportLogsHistory(report.id);
  const logs = useMemo(() => {
    let result = [];
    if (data) {
      result = _.flatten(data.pages.map(({ data: logGroup }) => logGroup));
    }
    return result;
  }, [data]);
  const renderLogs = useMemo(() => {
    return (
      <>
        <Collapse
          bordered={false}
          className="enoch-log-row"
          defaultActiveKey={['1']}
          expandIcon={({ isActive }) => (
            <Icon rotate={isActive ? 90 : 0} type="caret-right" />
          )}
        >
          {logs.map((item, itemIndex) => {
            const linebreakSplit = item.data.split('\n'),
              content = linebreakSplit.filter((line, i) => i > 0);
            return (
              <Collapse.Panel
                className={content.length ? '' : 'ant-collapse-no-content'}
                header={
                  <>
                    <span>
                      <i>
                        {moment(item.timestamp).format('YYYY-MM-DD HH:mm:ss')}
                      </i>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      {linebreakSplit[0]}
                    </span>
                  </>
                }
                key={item.id}
                style={{
                  ...customPanelStyle,
                  background: itemIndex % 2 === 0 ? 'rgba(0,0,0,0.05)' : '#fff',
                }}
              >
                <div
                  className="flex"
                  style={{
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <span>{content.join('\n')}</span>
                </div>
              </Collapse.Panel>
            );
          })}
        </Collapse>
        <div
          className="flex"
          style={{ justifyContent: 'center', marginTop: 10 }}
        >
          {hasNextPage && (
            <Button
              loading={isFetchingNextPage}
              onClick={() => fetchNextPage()}
            >
              {isFetchingNextPage ? 'Loading More...' : 'More Items'}
            </Button>
          )}
        </div>
      </>
    );
  }, [logs, isFetchingNextPage, fetchNextPage]);
  return (
    <>
      <Row>
        <Col span={12}>
          <b>IP Address:</b> {report.ipAddress}
        </Col>
        <Col span={12}>
          <b>Email:</b> {report.email}
        </Col>
      </Row>
      <Row style={{ marginTop: 10 }}>
        <Col span={12}>
          <b>Profile:</b> {report.profile}
        </Col>
        <Col span={12}>
          <b>Timestamp:</b>{' '}
          {moment(report.createdAt).format('YYYY-MM-DD HH:mm:ss')}
        </Col>
      </Row>
      <Spin spinning={isFetching && !isFetchingNextPage}>
        <h5>Logs</h5>
        {!logs.length ? <center>No logs found</center> : <>{renderLogs}</>}
      </Spin>
    </>
  );
}
